import React from "react";
import NewLoader from "../../../components/styled-components/loader/NewLoader";
import { T } from "antd/lib/upload/utils";
import { ToolTipCreator } from "../../../helpers/ToolTipCreator";
export const StrategyAmortization = ({
  amortizationData,
  loading,
  monthlyPayment,
}) => {
  const tableData =
    amortizationData &&
    amortizationData.allAmortizationData &&
    amortizationData.allAmortizationData.amortizationTable;
  // Format amounts with $ and 2 decimal places
  const formatAmount = (value) => {
    if (value === "" || value === null || value === undefined) return "-";

    // Convert everything to string first, then remove commas
    const cleaned = value.toString().replace(/,/g, "");

    // If still not a number, return as-is
    if (isNaN(cleaned)) return value;

    const num = parseFloat(cleaned);
    return `$${num.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  const updatedData =
    (tableData &&
      tableData.data &&
      tableData.data.map((row) => {
        return row.map((cell, i) => {
          if (i === 1) {
            // Snowball column
            const cleanedValue = cell && cell.toString().replace(/,/g, "") || "0";
            const snowballVal = parseFloat(cleanedValue);
            return (snowballVal).toFixed(2);
            // return (snowballVal + monthlyPayment).toFixed(2);
          }
          return cell;
        });
      })) ||
    [];

  return (
    <div
      className="debt-amortization-container"
      style={{ marginTop: "20px", position: "relative" }}
    >
      <div
        className="cardHeadingDebt"
        style={{ fontWeight: "bold", fontSize: "18px", marginBottom: "10px" }}
      >
        Amortization Details
      </div>

      {tableData && tableData.data && tableData.data.length > 0 ? (
        <div
          style={{
            maxHeight: "300px",
            overflowY: "auto",
            border: "1px solid #ddd",
            borderRadius: "8px",
          }}
        >
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              textAlign: "left",
            }}
          >
            <thead>
              <tr
                style={{
                  background: "rgb(244, 247, 254)",
                  position: "sticky",
                  top: 0,
                }}
              >
                {tableData.header.map((head, i) => (
                  <th key={i} style={thStyle}>
                    <span style={{display: "flex", alignItems: "baseline", gap: "3px"}}>{head} <ToolTipCreator name={head} /></span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {updatedData &&
                updatedData.map((row, rowIndex) => (
                  <tr key={rowIndex} style={{ borderBottom: "1px solid #eee" }}>
                    {row.map((cell, cellIndex) => (
                      <td key={cellIndex} style={tdStyle}>
                        {/*cell !== "" && !isNaN(cell)
                        ? formatAmount(cell)
                        : cell || "-" */}
                        {cellIndex === 0
                          ? cell // first column is Date → show as-is
                          : formatAmount(cell, cellIndex)}
                      </td>
                    ))}
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="debt-amortization-container-nocontent">
          <div className="debt-amortization-container-nocontent-heading">
            No List to Show
          </div>
        </div>
      )}
      <NewLoader isLoading={loading} />
    </div>
  );
};

const thStyle = {
  padding: "10px",
  fontFamily: "Poppins",
  borderBottom: "1px solid #ddd",
  fontWeight: "bold",
  color: "black",
  fontSize: "14px",
};

const tdStyle = {
  padding: "10px",
  fontSize: "14px",
  fontFamily: "Poppins",
  fontWeight: "500",
  color: "#6c757d",
  whiteSpace: "nowrap",
};
